import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";

function dateToString(x) {
  return (
    x.getFullYear().toString() + (x.getMonth() + 1).toString().padStart(2, "0")
  );
}

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function DateFilter(props) {
  const [showModal, setShowModal] = useState(false);
  const [dates, setDates] = useState([props.maxDate, props.minDate]);
  const [year, setYear] = useState(props.maxDate.getFullYear());
  const getInitialDates = (filters) => {
    if (filters.length === 0) {
      return [];
    } else {
      let startDate = new Date();
      let endDate = new Date();
      filters.forEach((filter) => {
        if (filter[0] === ">") {
          startDate = new Date(
            Date.UTC(filter.substr(1, 4), filter.substr(5, 2) - 1)
          );
        } else if (filter[0] === "<") {
          endDate = new Date(
            Date.UTC(filter.substr(1, 4), filter.substr(5, 2) - 1)
          );
        }
      });
      return [startDate, endDate];
    }
  };

  useEffect(() => {
    setYear(props.maxDate.getFullYear());
    setDates(getInitialDates(props.matchingFilterString));
  }, [props]);

  const handlePress = (month, year) => {
    if (dates.length === 0 || dates.length === 2) {
      setDates([new Date(Date.UTC(year, month))]);
    } else {
      let newDates = [...dates, new Date(Date.UTC(year, month))];
      newDates.sort((a, b) => a - b);
      setDates(newDates);
    }
  };

  const checkStatus = (year, month) => {
    let checkDate = new Date(Date.UTC(year, month));
    if (checkDate - dates[0] === 0 || checkDate - dates[1] === 0) {
      return "active";
    } else if (dates[0] < checkDate && dates[1] > checkDate) {
      return "between";
    } else {
      return "none";
    }
  };

  let nextYearPossible = props.maxDate.getFullYear() > year;
  let previousYearPossible = props.minDate.getFullYear() < year;

  return (
    <div>
      <div
        style={{ display: !showModal ? "block" : "none", padding: "10px 0px" }}
      >
        {props.matchingFilterString.length > 1 ? (
          <div style={{ cursor: "pointer" }} onClick={() => setShowModal(true)}>
            <div style={{ fontSize: 16 }}>
              {monthNames[
                getInitialDates(props.matchingFilterString)[0].getMonth()
              ] +
                " " +
                getInitialDates(props.matchingFilterString)[0].getFullYear()}
              {" - "}
              {monthNames[
                getInitialDates(props.matchingFilterString)[1].getMonth()
              ] +
                " " +
                getInitialDates(props.matchingFilterString)[1].getFullYear()}
            </div>
          </div>
        ) : (
          <div onClick={() => setShowModal(true)}>
            <div
              style={{
                fontSize: 14,
                color: "var(--primary-color-600)",
                fontWeight: 700,
              }}
            >
              Click to pick dates
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <div style={{ marginTop: 15, flex: 1, justifyContent: "center" }}>
          <div style={{ backgroundColor: "white" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                alignItems: "center",
              }}
            >
              <div
                disabled={!previousYearPossible}
                onClick={() => setYear(year - 1)}
                style={{
                  padding: "5px 10px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <i
                  style={{
                    fontSize: 25,
                    color: previousYearPossible
                      ? "var(--primary-color-500)"
                      : "#aaaaaa",
                  }}
                  className="far fa-angle-left"
                />
              </div>
              <div
                style={{
                  padding: "0px 10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div style={{ fontWeight: "600", fontSize: 18 }}>{year}</div>
              </div>
              <div
                disabled={!nextYearPossible}
                onClick={() => setYear(year + 1)}
                style={{
                  padding: "5px 10px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <i
                  style={{
                    fontSize: 25,
                    color: nextYearPossible
                      ? "var(--primary-color-500)"
                      : "#aaaaaa",
                  }}
                  className="far fa-angle-right"
                />
              </div>
            </div>

            <div
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                display: "flex",
                background: "#fcfcfc",
              }}
            >
              {[...Array(12).keys()].map((month) => {
                let status = checkStatus(year, month);
                let possible =
                  new Date(Date.UTC(year, month)) >= props.minDate &&
                  new Date(Date.UTC(year, month)) <= props.maxDate;

                return (
                  <div
                    style={{
                      width: "33%",
                      backgroundColor:
                        status !== "none"
                          ? "var(--primary-color-600)"
                          : "transparent",
                    }}
                    key={month}
                  >
                    <div
                      disabled={!possible}
                      style={{
                        padding: "5px 0px",
                        textAlign: "center",
                        backgroundColor:
                          status !== "none"
                            ? "var(--primary-color-600)"
                            : "transparent",
                      }}
                      onClick={() => handlePress(month, year)}
                    >
                      <div
                        style={{
                          color: possible
                            ? status !== "none"
                              ? "white"
                              : "black"
                            : "#aaaaaa",
                          fontWeight: status !== "none" ? "700" : "400",
                          fontSize: 16,
                        }}
                      >
                        {monthNames[month]}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div
              style={{ flexDirection: "row", marginTop: 20, marginBottom: 20 }}
            >
              <Button
                style={{ fontSize: 14 }}
                onClick={() => {
                  setShowModal(false);
                  props.updateFilters(
                    [
                      ">" + dateToString(dates[0]),
                      "<" + dateToString(dates[1]),
                    ],
                    props.filterType.data
                  );
                }}
                disabled={dates.length < 2}
                size="sm"
              >
                Apply Filter
              </Button>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => {
                  setShowModal(false);
                  setDates(getInitialDates(props.activeFilters));
                }}
                style={{ marginLeft: 10, fontSize: 14 }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DateFilter;
